export const isValidDashboardUser = (user) => {
  return user
    && (user.roles.COMMERCE_EDITOR || (user.roles.INSIGHTS_VIEWER && user.brands));
};

export const hasAccessToBrandId = (user, brandId) => {
  if (!isValidDashboardUser(user)) {
    return false;
  }

  return user.roles.COMMERCE_EDITOR || (user.brands && user.brands.includes(brandId));
};
